import { render, staticRenderFns } from "./ClientOverview_ListActivities.vue?vue&type=template&id=23fe762e&scoped=true&"
import script from "./ClientOverview_ListActivities.vue?vue&type=script&lang=js&"
export * from "./ClientOverview_ListActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fe762e",
  null
  
)

export default component.exports